/* «О бренде» — модалка на тёмной поверхности дизайн-системы. */
import { Link } from 'react-router-dom';
import Modal from './Modal.jsx';
import { useStore } from '../store/StoreContext.jsx';
import { imageUrl } from '../lib/api.js';

export default function BrandModal({ onClose }) {
  const { catalog } = useStore();

  return (
    <Modal title="О бренде" sub="SAINTS — киберспортивная команда и её мерч" dark wide onClose={onClose}>
      <div className="brand-modal">
        <div className="brand-modal__text">
          <p>
            SAINTS — команда по мобильному киберспорту. Мерч мы делаем для себя же: в джерси играем
            турниры, в напальчниках — тренировки, в худи ездим на буткемпы.
          </p>
          <p>
            Поэтому здесь нет «сувенирки»: ткани подбираем по плотности, принты — по стойкости
            к стиркам, а размерную сетку меряем на своих же игроках.
          </p>
          <div className="brand-modal__stats">
            <div>
              <b>{catalog.stats.products}</b>
              <span>позиций в дропе</span>
            </div>
            <div>
              <b>{catalog.stats.rating}</b>
              <span>средняя оценка</span>
            </div>
            <div>
              <b>СДЭК</b>
              <span>доставка по РФ и СНГ</span>
            </div>
          </div>
        </div>
        <div>
          <img src={imageUrl('/uploads/jersey.jpg')} alt="Мерч Saints" className="brand-modal__img" />
          <Link to="/about" className="btn btn--ghost-dark" style={{ marginTop: 14, width: '100%' }} onClick={onClose}>
            <span className="btn__label">Подробнее о бренде</span>
          </Link>
        </div>
      </div>
    </Modal>
  );
}
